import AuthProvider from 'context/AuthProvider';
import ErrorBoundary from 'context/ErrorBoundary';
import 'helpers/initFA';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';

const container = document.getElementById('main');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Main>
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </Main>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log(
          'Service Worker registered with scope:',
          registration.scope
        );
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
